import { Icon } from '@mui/material';
import { Breadcrumbs, EmptyState, RBButton } from '@scmlatam/web-ui';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Table } from '../components/Table';
import { useUndoConfirm } from '../hooks/useUndoConfirm';
import { useTable } from '../hooks/useTable';
import { UndoConfirm } from '../components/UndoConfirm';
import { useDeleteConfirm } from '../hooks/useDeleteConfirm';
import { DeleteConfirm } from '../components/DeleteConfirm';

const SubPage = () => {
    const { t } = useTranslation('execute_report.table');

    const deleteConfirmSetOpenRef = useRef<(open: boolean) => void>(() => { });
    const undoConfirmSetOpenRef = useRef<(open: boolean) => void>(() => { });

    const tableProps = useTable({
        setOpenUndoConfirm: (open) => undoConfirmSetOpenRef.current(open),
        setOpenDeleteConfirm: (open) => deleteConfirmSetOpenRef.current(open),
    });

    const deleteConfirmProps = useDeleteConfirm(tableProps.search, tableProps.selectedRowIds);

    const undoConfirmProps = useUndoConfirm(tableProps.search, tableProps.selectedRowIds);

    deleteConfirmSetOpenRef.current = deleteConfirmProps.setOpen;
    undoConfirmSetOpenRef.current = undoConfirmProps.setOpen;

    return (
        <div
            style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
            }}
            className="grid gap-5"
        >
            <Breadcrumbs queryKeys={['module', 'view']} className="w-full" />

            {tableProps.canCreateReport && <RBButton
                variant="primary"
                size="m"
                rightIcon={<Icon baseClassName="material-symbols-rounded">add</Icon>}
                onClick={() => {
                    window.history.pushState(null, '', '/reports?module=reports&view=execute_report');
                    window.dispatchEvent(new PopStateEvent('popstate'));
                }}
            >
                {t('filter.create_new_report')}
            </RBButton>}

            {tableProps.canViewTable ? (
                <Table {...tableProps} />
            ) : (
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <EmptyState variant="no-permission" context="page" permissions={tableProps.requiredPermissions.map((permission) => permission.permission)} />
                </div>
            )}

            {tableProps.canViewTable && tableProps.canDeleteResult && <UndoConfirm {...undoConfirmProps} />}

            {tableProps.canViewTable && tableProps.canDeleteResult && <DeleteConfirm {...deleteConfirmProps} />}
        </div>
    );
};

export { SubPage };
